import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { DropdownMenuTrigger } from '@src/design-system/dropdown-menu';
import type { TMember } from '@src/shared/types/member';

export function ProfileMenuTrigger({
  member,
  currentOrgName,
  currentOrgCountry,
}: {
  member?: TMember;
  currentOrgName: string;
  currentOrgCountry: string;
}) {
  return (
    <DropdownMenuTrigger className='border cursor-pointer hover:border-primary-300 transition-all duration-200 max-w-[200px] flex items-center gap-2 rounded-2xl tex px-3 py-2 border-pale-border'>
      <Avatar className='size-10 border border-primary-100'>
        <AvatarImage src={member?.avatar} />
        <AvatarFallback colorId={Number(member?.id)}>
          {`${member?.first_name} ${member?.last_name}`.substring(0, 2)}
        </AvatarFallback>
      </Avatar>

      <div className='flex flex-col items-start text-gray-800 font-medium truncate text-sm'>
        {`${member?.first_name} ${member?.last_name}`}
        <p className='truncate flex gap-1 items-center w-full text-secondary-1000 text-xs capitalize'>
          <span className='truncate inline-block'>{currentOrgName}</span>-
          <span>{currentOrgCountry}</span>
        </p>
      </div>
    </DropdownMenuTrigger>
  );
}
